<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3 max-w-1400">
        <h1>ข้อตกลงความเป็นส่วนตัว</h1>
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Chính sách bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import importedImg1 from "@/page/mirasolcompany/components/img/4_1.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      text: `พวกเรา ใส่ใจในความเป็นส่วนตัวของลูกค้าของเรา ดังนั้นเราจึงเผยแพร่นโยบายความเป็นส่วนตัว (“นโยบาย”) เพื่อแจ้งให้ลูกค้าของเราทราบเกี่ยวกับนโยบายของเราที่เกี่ยวข้องกับการรวบรวม การใช้ และการเปิดเผยข้อมูลส่วนบุคคลของคุณ (“คุณ”) ตามกฎหมายและระเบียบข้อบังคับที่เกี่ยวข้อง เมื่อได้รับอนุญาตอย่างชัดแจ้งจากคุณ บริษัทของเราจะรวบรวมและใช้ข้อมูลส่
1. เรารวบรวมข้อมูลส่วนบุคคลของคุณอย่างไร
เรารวบรวมข้อมูลส่วนบุคคลของคุณเมื่อจำเป็นหรือมีพื้นฐานทางกฎหมายเท่านั้น ซึ่งรวมถึงที่ที่เราเก็บรวบรวมข้อมูลส่วนบุคคลของคุณโดยอิงจากเหตุและภาระผูกพันทางกฎหมาย การปฏิบัติตามสัญญาที่คุณทำไว้กับเรา ผลประโยชน์โดยชอบด้วยกฎหมายของเรา การดำเนินการภายใต้ความยินยอมของคุณ และพื้นฐานทางกฎหมายอื่นๆ โดยการใช้แอปพลิเคชันนี้ คุณยินยอมอย่างชัดแจ้งในการเก็บรวบรวมข้อมูลส่วนบุคคลของคุณด้วยวิธีต่อไปนี้:
1.1 ข้อมูลพื้นฐานส่วนบุคคลของผู้ใช้
เมื่อลงทะเบียนเป็นผู้ใช้ คุณจะต้องให้ข้อมูลต่อไปนี้เกี่ยวกับข้อมูลพื้นฐานที่จำเป็นของคุณเองระหว่างการใช้แอปพลิเคชันนี้ คือ (1)ชื่อเต็ม (2)วัน เดือน ปีเกิด (3)เพศ (4)ที่อยู่อาศัย (5) หมายเลขโทรศัพท์ (6) ข้อมูลติดต่อฉุกเฉิน (7) หมายเลขบัตรประชาชน  (8) ข้อมูลบัญชีธนาคารของผู้รับผลประโยชน์
1.2 ข้อมูลที่เก็บรวบรวมระหว่างการใช้บริการ
เรารวบรวมข้อมูลเกี่ยวกับแอปพลิเคชันและอุปกรณ์ที่คุณใช้เพื่อเข้าถึงบริการของเรา ข้อมูลและการอนุญาตที่เรารวบรวมมีดังนี้:
1.2.1 ตำแหน่งที่ตั้ง
เราจะรวบรวมข้อมูลตำแหน่งทางภูมิศาสตร์ปัจจุบันของคุณเมื่อคุณใช้แอปพลิเคชันนี้ เราจะหยุดรวบรวมข้อมูลตำแหน่งทางภูมิศาสตร์ของคุณเมื่อแอปพลิเคชันนี้ทำงานอยู่เบื้องหลัง คุณสามารถเลือกที่จะปิดใช้งานข้อมูลการติดตามตำแหน่งทางภูมิศาสตร์บนอุปกรณ์มือถือของคุณเป็นการชั่วคราวได้ตลอดเวลา
1.2.2 รายชื่อติดต่อ
ในกระบวนการกู้ยืม เราต้องการให้ผู้ใช้เลือกผู้ติดต่อฉุกเฉินจากรายชื่อผู้ติดต่อ  ดังนั้นเราจึงรวบรวมข้อมูลติดต่อของผู้ใช้เพื่อให้สามารถกรอกข้อมูลโดยอัตโนมัติในระหว่างขั้นตอนการสมัครสินเชื่อ  นอกจากนี้เราใช้ข้อมูลติดต่อเพื่อวิเคราะห์ความเสี่ยงและประเมินคุณสมบัติของผู้ใช้ในการใช้ผลิตภัณฑ์หรือบริการของเรา (รวมถึงแต่ไม่จำกัดเพียงการประเมินชื่อเสียงของผู้ใช้ การพิจารณาว่าผู้ใช้สามารถซื้อผลิตภัณฑ์หรือบริการที่ผู้ใช้ร้องขอได้หรือไม่ และ/หรือการพิจารณาว่า ผู้ใช้มีคุณสมบัติสำหรับผลประโยชน์เพิ่มเติมของผลิตภัณฑ์หรือไม่) ให้บริการสินเชื่อแก่ผู้ใช้ (รวมถึงแต่ไม่จำกัดเพียงการประมวลผลธุรกรรมของผู้ใช้และการประมวลผลการชำระเงินกู้ และการรวบรวมการชำระคืนเงินกู้ของผู้ใช้) ตรวจสอบตัวตนผู้ใช้และ/หรือข้อกำหนดของผู้ใช้ ให้ข้อมูลอื่นแก่เรา ตรวจสอบ ต่อต้านและป้องกันหรือพยายามฉ้อโกง การฟอกเงิน และ/หรือการใช้บริการของเราอย่างผิดกฎหมาย วิเคราะห์พฤติกรรมของลูกค้า ตามวัตถุประสงค์ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้ ใช้การโทรอัตโนมัติหรือการโทรด้วยข้อความที่บันทึกไว้ล่วงหน้าเพื่อติดต่อคุณทางโทรศัพท์
ทั้งนี้ข้อมูลผู้ติดต่อทั้งหมดจะถูกเข้ารหัสและอัปโหลดไปยังเซิร์ฟเวอร์ของเรา ผ่านแอปพลิเคชัน แต่เราจะกรองและลบข้อมูลผู้ติดต่อส่วนบุคคลจากเซิร์ฟเวอร์ของเราในครึ่งปีหลัง และเราจะไม่แบ่งปันข้อมูลนี้กับบุคคลที่สาม หากคุณต้องการลบข้อมูลผู้ติดต่อทันที คุณต้องแจ้งศูนย์บริการลูกค้าของเราทางอีเมล
1.2.3 กล้อง&ภาพถ่าย
เราต้องการการอนุญาตจากกล้องเพื่อให้คุณสามารถถ่ายภาพเอกสาร KYC ของคุณพร้อมกับเอกสารที่จำเป็นอื่นๆ และอัปโหลดเอกสารเดียวกันในแอปพลิเคชันนี้ เรายังต้องการการอนุญาตสื่อ ภาพถ่าย และไฟล์ที่ช่วยให้คุณสามารถอัปโหลดรูปถ่ายหรือเอกสารในเครื่องของคุณเพื่อกรอกแบบฟอร์มใบสมัคร
1.2.4 ปฏิทิน
การอนุญาตให้เข้าถึงปฏิทินของคุณช่วยให้เราเตือนคุณถึงวันครบกำหนดชำระคืน
1.2.5 การจัดเก็บ
เราเขียนไฟล์ไปยังตำแหน่งเฉพาะตามความจำเป็น และอ่านไฟล์เหล่านี้เมื่อจำเป็น (ซึ่งอาจรวมถึงแต่ไม่จำกัดเพียงไฟล์ชั่วคราว แคช เป็นต้น)
1.2.6 ข้อความ SMS
เราตรวจสอบเฉพาะข้อความทางการเงิน (ข้อความทางการเงิน 4 หลัก) รวมถึงผู้ส่ง ข้อความและวันที่จัดส่งในกล่องจดหมายของผู้ใช้ ซึ่งช่วยให้เราระบุบัญชีต่างๆ ที่ผู้ใช้ถือครองและรูปแบบกระแสเงินสดที่ผู้ใช้มีได้ ช่วยเหลือ เรากำหนดโปรไฟล์ความเสี่ยงของผู้ใช้และให้การวิเคราะห์สินเชื่อที่เหมาะสมแก่ผู้ใช้  นอกจากนี้ เรารวบรวมและประมวลผลข้อมูลโทรศัพท์ เช่น บันทึก SMS  สำหรับการวิเคราะห์ความเสี่ยง เพื่อประเมินคุณสมบัติของผู้ใช้ในการใช้ผลิตภัณฑ์หรือบริการของเรา (รวมถึงแต่ไม่จำกัดเพียงการประเมินชื่อเสียงของผู้ใช้ การพิจารณาว่าผู้ใช้สามารถซื้อผลิตภัณฑ์หรือบริการที่ร้องขอโดยผู้ใช้ได้หรือไม่ และ/หรือการพิจารณาว่าผู้ใช้มีสิทธิ์หรือไม่ สำหรับผลิตภัณฑ์และสิทธิประโยชน์เพิ่มเติมที่มีอยู่) ให้บริการสินเชื่อแก่ผู้ใช้ (รวมถึงแต่ไม่จำกัดเฉพาะการประมวลผลธุรกรรมของคุณและประมวลผลการชำระเงินกู้ของผู้ใช้และการรวบรวมการชำระคืนเงินกู้ของผู้ใช้) ตรวจสอบตัวตนของผู้ใช้และ/หรือข้อมูลอื่น ๆ ที่ผู้ใช้มอบให้เรา ตรวจสอบ ต่อต้านและป้องกันหรือพยายามฉ้อโกง การฟอกเงิน และ/หรือการใช้บริการของเราอย่างผิดกฎหมาย วิเคราะห์พฤติกรรมของลูกค้า ติดต่อกับหน่วยงานอ้างอิงเครดิตหรือป้องกันการฉ้อโกง ให้บริการหรือสนับสนุนลูกค้า
ใช้ข้อความ (SMS) (ถ้ามี) เพื่อติดต่อคุณเพื่อวัตถุประสงค์ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้
ทั้งนี้ข้อมูล SMS ทั้งหมดจะถูกเข้ารหัสและอัปโหลดไปยังเซิร์ฟเวอร์ของเรา ผ่านแอปพลิเคชัน แต่เราจะกรองและลบข้อมูล SMS ส่วนบุคคลจากเซิร์ฟเวอร์ของเราในครึ่งปีหลัง และเราจะไม่แบ่งปันข้อมูลนี้กับบุคคลที่สาม หากคุณต้องการลบข้อมูลแอพที่ติดตั้งทันที คุณต้องแจ้งศูนย์บริการลูกค้าของเราทางอีเมล
1.2.7 ข้อมูลอุปกรณ์อื่นๆ
เมื่อคุณใช้แอปพลิเคชันนี้ เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลอุปกรณ์บางอย่างโดยอัตโนมัติ ซึ่งส่งมาจากอุปกรณ์มือถือของคุณ ซึ่งรวมถึงยี่ห้ออุปกรณ์ รุ่น เวอร์ชันระบบปฏิบัติการ สภาพแวดล้อมเครือข่ายอุปกรณ์ WiFi สถานะอุปกรณ์ ข้อมูลซอฟต์แวร์แอปพลิเคชัน หมายเลขโทรศัพท์มือถือ ข้อมูลหน่วยความจำอุปกรณ์ การอนุญาตให้เข้าถึงข้อมูลนี้ช่วยให้เราระบุตัวตนและความชอบของผู้ใช้ของคุณ และเพื่อแนะนำผลิตภัณฑ์สินเชื่อที่เหมาะสม
เราจะไม่เก็บข้อมูลข้างต้นทั้งหมดไว้ตลอดไป เราจะลบข้อมูลทิ้งหลังการใช้งาน
2. วิธีที่เราใช้ข้อมูลส่วนบุคคลของคุณ
2.1 เราจะประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อให้บริการหรือผลิตภัณฑ์ที่คุณร้องขอเป็นหลัก อย่างไรก็ตาม อาจมีบางครั้งที่เราจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลที่ไม่ได้เป็นส่วนหนึ่งของธุรกิจหลักของเรา ตัวอย่างเช่น เราต้องปฏิบัติตามภาระผูกพันทางกฎหมายหรือหน้าที่สาธารณะตามที่กฎหมายกำหนด
2.2 เราอาจใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้:
• ช่วยเหลือคุณในการลงทะเบียนและตรวจสอบขั้นตอน;
• สมัครสินเชื่อ;
• การสาธิตผลิตภัณฑ์และ/หรือบริการ
• เพิ่มความปลอดภัยให้กับผลิตภัณฑ์และ/หรือบริการของเรา;
• แก้ไขปัญหาที่คุณอาจพบขณะใช้ผลิตภัณฑ์และ/หรือบริการของเรา
เราจะเก็บข้อมูลส่วนบุคคลของคุณไว้ตราบเท่าที่กฎหมายกำหนดและจำเป็นเพื่อให้เป็นไปตามวัตถุประสงค์ในการรวบรวมและใช้ข้อมูล เมื่อข้อมูลส่วนบุคคลของคุณเกินระยะเวลาเก็บรักษา เราจะลบข้อมูลส่วนบุคคลของคุณหรือปิดบังข้อมูลดังกล่าวตามข้อกำหนดทางกฎหมายที่บังคับใช้
3. วิธีที่เราเปิดเผยและถ่ายโอนข้อมูลส่วนบุคคลของคุณ
เราจะไม่แบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลที่สามเพื่อการใช้งานเชิงพาณิชย์หรือการตลาดโดยไม่ได้รับความยินยอมจากคุณ โดยการยอมรับนโยบายความเป็นส่วนตัวนี้ เราจะแบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลที่สามภายใต้สถานการณ์ต่อไปนี้
• การเปิดเผยต่อพนักงานที่ได้รับอนุญาตของบริษัทและบริษัทในเครือ ซึ่งรวมถึงผู้ตรวจสอบบัญชีของบริษัทหรือผู้ตรวจสอบภายนอก สถาบันสหกรณ์ทางการเงิน และ/หรือบุคคลภายนอกที่เกี่ยวข้องกับบริษัทของเรา
• การเปิดเผยข้อมูลเพื่อให้คุณสามารถซื้อขายและ/หรือใช้บริการที่คุณต้องการ;
• การเปิดเผยข้อมูลต่อเครดิตบูโร (หน่วยงานรายงานเครดิตประเภทหนึ่ง);
• การเปิดเผยภายใต้การสอบสวนทางกฎหมายหรือการดำเนินการทางกฎหมาย;
• การเปิดเผยตามกฎหมาย คำสั่งของรัฐบาล หรือข้อกำหนดด้านกฎระเบียบ
นอกจากบุคคลที่ระบุไว้ข้างต้นแล้ว เรายังทำสัญญากับบริษัทบุคคลที่สามอื่นๆ เพื่อช่วยให้คุณประสบความสำเร็จในการขอสินเชื่อ ซึ่งรวมถึง: สถาบันสหกรณ์บุคคลที่สาม เช่น ผู้ให้กู้กองทุน พันธมิตรการชำระเงิน พันธมิตรหลังการกู้ยืม การตรวจสอบจากบุคคลที่สาม ผู้ให้บริการ ผู้ให้บริการข้อความ พันธมิตรบริการโทรออก
3. สิทธิ์ในข้อมูลของคุณ
คุณมีสิทธิบางอย่างเกี่ยวกับข้อมูลส่วนบุคคลของคุณ สิทธิเหล่านี้รวมถึง:
• สิทธิ์ในการเข้าถึงข้อมูลส่วนบุคคลของคุณ
• สิทธิ์ในการแก้ไขหรืออัปเดตข้อมูลส่วนบุคคลของคุณ
• สิทธิ์ในการพกพา
• สิทธิ์ในการเพิกถอนความยินยอมหากคุณให้ไว้ก่อนหน้านี้
• สิทธิ์ในการยื่นคำร้องต่อหน่วยงานคุ้มครองข้อมูล
หากคุณต้องการส่งคำขอเกี่ยวกับสิทธิ์ของคุณ โปรดติดต่อฝ่ายสนับสนุนลูกค้าโปรดทราบว่าเราอาจจำเป็นต้องขอข้อมูลเพิ่มเติมจากคุณเพื่อดำเนินการตามคำขอการสื่อสารจากคุณ (เช่น คำขอบริการ)
4. เราปกป้องข้อมูลอย่างไร
เราเข้าใจถึงความสำคัญของการรักษาข้อมูลของคุณให้ปลอดภัย เราพยายามอย่างเหมาะสมในการปกป้องข้อมูลส่วนบุคคลของคุณและรับรองความปลอดภัยของระบบของเรา เพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการเข้าถึงและการใช้งานโดยไม่ได้รับอนุญาต เราใช้มาตรการรักษาความปลอดภัยที่สอดคล้องกับกฎหมายที่บังคับใช้
มาตรการเหล่านี้รวมถึงการป้องกันคอมพิวเตอร์และไฟล์ที่มีการรักษาความปลอดภัย หากคุณพบการรั่วไหลของข้อมูลส่วนบุคคลที่น่าสงสัย โปรดติดต่อเราทันที
นอกจากมาตรการรักษาความปลอดภัยทั่วไปข้างต้นแล้ว บริษัทของเรายังใช้เทคโนโลยีความปลอดภัยขั้นสูงต่อไปนี้เพื่อปกป้องข้อมูลส่วนบุคคลของคุณ:
• การตรวจจับการบุกรุก: ระบบซอฟต์แวร์ที่ใช้ในการตรวจจับและป้องกันการโจมตีของแฮ็กเกอร์ที่ไม่ได้รับอนุญาต บริษัทของเราใช้ระบบที่มีประสิทธิภาพและจะปรับปรุงระบบดังกล่าวเป็นประจำ
• ไฟร์วอลล์: ระบบซอฟต์แวร์ที่อนุญาตให้เฉพาะพนักงานที่ได้รับอนุญาตจากบริษัทของเราเท่านั้นในการเข้าถึงข้อมูลส่วนบุคคลของคุณ บริษัทของเราใช้ระบบป้องกันไฟร์วอลล์แบบคู่
• การสแกนไวรัส: บริษัทของเราติดตั้งซอฟต์แวร์ป้องกันไวรัสที่มีประสิทธิภาพในระบบของบริษัทเป็นประจำ และติดตั้งซอฟต์แวร์สแกนไวรัสบนเซิร์ฟเวอร์โดยเฉพาะ
• เทคโนโลยีการเข้ารหัสข้อมูล: เทคโนโลยีการเข้ารหัสที่ใช้ในการเข้าถึงข้อมูลเพื่อป้องกันการดักฟังระหว่างการส่งผ่านอินเทอร์เน็ต โดยใช้เทคโนโลยีนี้ บุคคลที่ตั้งใจจะสกัดกั้นข้อมูลหรือแฮ็กเกอร์ไม่สามารถเข้าใจความหมายของข้อมูลที่ถูกจับได้ เทคโนโลยีนี้ยังสามารถใช้เพื่อตรวจสอบการมีอยู่ของเว็บไซต์ของบริษัท ซึ่งใช้ SSL แบบ 128 บิต (SSL.1 สำหรับการส่งข้อมูล)
• การเข้ารหัสข้อมูล: ใช้สำหรับข้อมูลที่ละเอียดอ่อนอย่างยิ่ง บริษัทใช้มาตรการรักษาความปลอดภัยที่เข้มงวด ก่อนนำเข้าข้อมูลเข้าสู่ฐานข้อมูลคอมพิวเตอร์ของบริษัท จะใช้รูปแบบที่ซับซ้อนในการเข้ารหัส ดังนั้นไม่มีใคร แม้แต่พนักงานของบริษัทก็ไม่ทราบข้อมูลสำคัญดังกล่าว
• คุกกี้: ไฟล์ขนาดเล็กในคอมพิวเตอร์ที่สามารถจัดเก็บข้อมูลสำคัญบนคอมพิวเตอร์ชั่วคราวเพื่ออำนวยความสะดวกในการสื่อสารโทรคมนาคม บริษัทของเราให้ความสำคัญอย่างยิ่งต่อความเป็นส่วนตัวของคุณ ดังนั้น โปรดใช้คุกกี้ด้วยความระมัดระวัง อย่างไรก็ตาม หากจำเป็นต้องใช้คุกกี้ บริษัทของเราจะพิจารณาและให้ความสำคัญกับความปลอดภัยและความเป็นส่วนตัวของคุณอย่างรอบคอบก่อน
• ออกจากระบบอัตโนมัติ: หลังจากเสร็จสิ้นการทำธุรกรรมโดยใช้บริการของเราแล้ว โปรดอย่าลืมออกจากระบบ หากคุณลืมออกจากระบบ ระบบจะออกจากระบบโดยอัตโนมัติในช่วงเวลาที่เหมาะสมเพื่อความปลอดภัยของคุณ
5. การแก้ไขนโยบายความเป็นส่วนตัว
เราขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลาตามดุลยพินิจของเราแต่เพียงผู้เดียว นโยบายที่โพสต์เมื่อใดก็ได้เป็นนโยบายที่มีผลบังคับใช้ เวอร์ชันปัจจุบันจะอยู่ที่แอปพลิเคชันนี้เสมอ เราขอแนะนำให้คุณตรวจสอบข้อมูลอัปเดตต่างๆ เป็นประจำ การเข้าถึงหรือการใช้แอปพลิเคชันนี้หรือบริการของเราหลังจากการเปลี่ยนแปลงหรือการแก้ไขมีผลบังคับคือการยอมรับและยอมรับนโยบายใหม่ของคุณ`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}
.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}
.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 2800px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}
.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem2 {
  max-width: 100%;
}
.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
h1 {
  /* margin-top: 50px; */
  /* margin-left: 490px; */
  color: #333333;
  font-size: 36px;
  font-weight: 700;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}
.img3{
  padding-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}
.imgBox2 {
  transform: scale(90%);
  margin: -80px auto 50px;
  height: 2750px;
  box-shadow: 0 6px 14px rgba(64, 4, 117, 0.25);
}

.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0baf60;
  margin: 0 500px;
}
</style>
